module.exports = __webpack_public_path__ + "img/113.0ac71d2d.jpg";